<div class="splash-container">
  <div class="splash-content">
    <img src="assets/splash_art/camion_loading_starco.gif" alt="Loading..." class="splash-image" />
  </div>
</div>
